import { useChat } from '@ai-sdk/react';
import { useEffect } from 'react';
const CHAT_MESSAGES_STORAGE_KEY = 'ballpark_chat_messages';
export function useChatWithStorage(options) {
    const chat = useChat(options);
    // Load messages from localStorage on mount
    useEffect(() => {
        const storedMessages = localStorage.getItem(CHAT_MESSAGES_STORAGE_KEY);
        if (storedMessages) {
            try {
                const parsedMessages = JSON.parse(storedMessages);
                chat.setMessages(parsedMessages);
            }
            catch (e) {
                console.error('Failed to parse stored messages:', e);
            }
        }
    }, []);
    // Save messages to localStorage when the chat has finished streaming
    useEffect(() => {
        if (chat.status === 'ready' && chat.messages.length > 0) {
            localStorage.setItem(CHAT_MESSAGES_STORAGE_KEY, JSON.stringify(chat.messages));
        }
    }, [chat.messages, chat.status]);
    return chat;
}
export function clearChatMessages() {
    localStorage.removeItem(CHAT_MESSAGES_STORAGE_KEY);
}
